export default __webpack_public_path__ + "static/media/all.80fef295.svg";